import { render, staticRenderFns } from "./ReminderCount.vue?vue&type=template&id=6c8b0087&"
import script from "./ReminderCount.vue?vue&type=script&lang=ts&"
export * from "./ReminderCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports